export type VocabularyTermSource = 'account' | 'system'

export interface VocabularyTerm {
  id: string
  term: string
  source: VocabularyTermSource
}

export const DEFAULT_TERM_LIMIT = 200
export const DEFAULT_MAX_WORDS_PER_TERM = 6
export const DEFAULT_MAX_TERM_LENGTH = 50

export const VOCABULARY_QUOTA = 'ai.accountVocabulary.value'

export const HIGHLIGHT_DURATION_MS = 5000
